import React from "react";
import { useTranslation } from "react-i18next";

const Title = () => {
    const {t} = useTranslation();

    return (
        <h1 className={`customer_requested_taxes_title`}>
            {t(`CustomerRequestedTaxes.title`)}
        </h1>
    );
};

export default Title;
